import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';
import type CompanyModel from './company.ts';
import type TasProgramTemplateModel from './tas-program-template.ts';
import type TasGroupingModel from './tas-grouping.ts';
import { Type } from '@warp-drive/core-types/symbols';

type configType = { employment_type?: string };

export default class TasGroupModel extends Model {
  @attr declare flavor: string;
  @attr declare config: configType;
  @attr declare name: string;

  /*************************
   **  Relationships      **
   *************************/

  @hasMany('tas-grouping', { async: false, inverse: 'tasGroup' })
  declare tasGroupings: TasGroupingModel[];
  @belongsTo('tas-program-template', { async: false, inverse: 'tasGroups' })
  declare tasProgramTemplate: TasProgramTemplateModel[];
  @belongsTo('company', { async: false, inverse: 'tasGroups' })
  declare company: CompanyModel;

  [Type] = 'tas-group' as const;
}
